import { graphicFadeIn, segmentFadeIn, tagFadeIn } from "./common";

export function commonLineFadeIn(line, label, duration, delay, easing) {
    segmentFadeIn(line, delay, duration, easing), tagFadeIn(label, delay, duration, easing);
}

export function areaFadeIn(area, label, duration, delay, easing) {
    graphicFadeIn(area, delay, duration, easing), tagFadeIn(label, delay, duration, easing);
}

export function arcAreaFadeIn(area, label, duration, delay, easing) {
    graphicFadeIn(area, delay, duration, easing), tagFadeIn(label, delay, duration, easing);
}

export function pointFadeIn(itemLine, decorativeLine, item, duration, delay, easing) {
    var _a;
    segmentFadeIn(itemLine, delay, duration, easing), graphicFadeIn(decorativeLine, delay, duration, easing), 
    (null === (_a = item.getTextShape) || void 0 === _a ? void 0 : _a.call(item)) ? tagFadeIn(item, delay, duration, easing) : graphicFadeIn(item, delay, duration, easing);
}
//# sourceMappingURL=fade-in.js.map
